// meta-pixel-services.ts
// Helper for Meta Pixel (Facebook Pixel) integration using provided Pixel ID and code

const META_PIXEL_ID = '1959249141597246';

export const initMetaPixel = () => {
  if (window.fbq) return;
  (function(f: any, b: Document, e: string, v: string, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    }
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  if (window.fbq) {
    (window.fbq as any)('init', META_PIXEL_ID);
    (window.fbq as any)('track', 'PageView');
  }
};

export const trackMetaPixel = (event: string, params?: Record<string, any>) => {
  if (!window.fbq) return;
  (window.fbq as any)('track', event, params);
};

declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
    _fbq?: any;
  }
}
